@if (loading$ | async) {
  <div>
    <div class="loading-dialog">
      <mat-spinner diameter="32"></mat-spinner>
      <!-- Spinner with 50px diameter -->
    </div>
  </div>
}
